import { Button } from '@repo/ui/components/button';
import { Skeleton } from '@repo/ui/components/skeleton';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';
import { MathJaxProvider } from '../../components/rich-text';
import { SetDetailView } from '../../components/sets/SetDetailView';
import { QueryErrorState } from '../../components/shell/QueryErrorState';
import { useQuestionSetSummary } from '../../queries/sets';

export const Route = createFileRoute('/_admin/sets_/$id')({
  component: SetShowRoute,
});

function SetShowRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: set, isLoading, isError, error, refetch } = useQuestionSetSummary(id);

  return (
    <div className="h-full w-full overflow-auto px-6 pt-8 pb-12">
      <div className="mx-auto mb-4 max-w-3xl">
        <Button
          variant="ghost"
          size="sm"
          className="rounded-sm -ml-2"
          onClick={() => navigate({ to: '/sets' })}
        >
          <ChevronLeft className="size-4" />
          প্রশ্নসেট লাইব্রেরি
        </Button>
      </div>

      {isLoading && <DetailSkeleton />}

      {isError && (
        <div className="mx-auto max-w-3xl">
          <QueryErrorState
            title="সেট পাওয়া যায়নি"
            message={(error as Error | undefined)?.message ?? 'অজানা ত্রুটি'}
            onRetry={() => void refetch()}
          />
        </div>
      )}

      {!isLoading && !isError && set && (
        <MathJaxProvider>
          <SetDetailView set={set} />
        </MathJaxProvider>
      )}
    </div>
  );
}

function DetailSkeleton() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-4">
      <Skeleton className="h-8 w-2/3 rounded-sm" />
      <Skeleton className="h-24 w-full rounded-sm" />
      <Skeleton className="h-40 w-full rounded-sm" />
      <Skeleton className="h-40 w-full rounded-sm" />
    </div>
  );
}
